module.exports = require('./dist/inputs/input');
